import { useMemo } from 'react';
import { useModalControl, ModalControlResponse } from '@frontend/design-system';

export interface CallRouteModalControls {
  deleteModal: ModalControlResponse;
  sidePanel: ModalControlResponse;
  editPhoneNumbers: ModalControlResponse;
  editExtensions: ModalControlResponse;
  changeLocation: ModalControlResponse;
  renameCallRoute: ModalControlResponse;
  editOverride: ModalControlResponse;
  addStep: ModalControlResponse;
  confirmation: ModalControlResponse;
  forceReset: ModalControlResponse;
  editBreak: ModalControlResponse;
  phoneTreeOverrideUsage: ModalControlResponse;
}

/**
 * Hook to manage all modal/tray controls for the CallRouteDetails component.
 * Groups all modal controls in one place for easier management.
 * Returns a memoized object to prevent unnecessary re-renders.
 */
export const useCallRouteModals = (): CallRouteModalControls => {
  const deleteModal = useModalControl();
  const sidePanel = useModalControl();
  const editPhoneNumbers = useModalControl();
  const editExtensions = useModalControl();
  const changeLocation = useModalControl();
  const renameCallRoute = useModalControl();
  const editOverride = useModalControl();
  const addStep = useModalControl();
  const confirmation = useModalControl();
  const forceReset = useModalControl();
  const editBreak = useModalControl();
  const phoneTreeOverrideUsage = useModalControl();

  return useMemo(
    () => ({
      deleteModal,
      sidePanel,
      editPhoneNumbers,
      editExtensions,
      changeLocation,
      renameCallRoute,
      editOverride,
      addStep,
      confirmation,
      forceReset,
      editBreak,
      phoneTreeOverrideUsage,
    }),
    [
      deleteModal,
      sidePanel,
      editPhoneNumbers,
      editExtensions,
      changeLocation,
      renameCallRoute,
      editOverride,
      addStep,
      confirmation,
      forceReset,
      editBreak,
      phoneTreeOverrideUsage,
    ]
  );
};
